// components/pricing/SingleSessionPricing/SingleSessionBookingModal.jsx
import React from "react";
import styled from "styled-components";
import { Button } from "../../../styles/components";
import { formatCurrency } from "../../../utils/format";

export const SingleSessionBookingModal = ({ packageDetails, onClose }) => {
	return (
		<Modal onClick={onClose}>
			<ModalContent onClick={(e) => e.stopPropagation()}>
				<Title>{packageDetails.name} Booking</Title>
				<Text>
					Online booking is not available for single sessions at this time.
				</Text>
				<PriceInfo>
					Price: Rs {formatCurrency(packageDetails.price).replace("Rs", "")}
				</PriceInfo>
				<Text>To book this package, please contact us:</Text>
				<ContactInfo>
					<ContactLink href="tel:+94777715439">📞 Call Now</ContactLink>
					<ContactLink
						href={`https://wa.me/94777715439?text=Hi,%20I'm%20interested%20in%20booking%20the%20${packageDetails.name}%20package`}
						target="_blank"
						rel="noopener noreferrer"
					>
						📱 WhatsApp
					</ContactLink>
				</ContactInfo>
				<ButtonWrapper>
					<Button onClick={onClose} variant="outlined">
						Close
					</Button>
				</ButtonWrapper>
			</ModalContent>
		</Modal>
	);
};

const Modal = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
`;

const ModalContent = styled.div`
	background: white;
	padding: ${(props) => props.theme.spacing.xl};
	border-radius: ${(props) => props.theme.borderRadius.lg};
	max-width: 500px;
	width: 90%;
`;

const Title = styled.h3`
	margin-bottom: ${(props) => props.theme.spacing.lg};
	font-size: ${(props) => props.theme.typography.sizes.xl};
	color: ${(props) => props.theme.colors.text.primary};
`;

const Text = styled.p`
	margin-bottom: ${(props) => props.theme.spacing.md};
	color: ${(props) => props.theme.colors.text.secondary};
`;

const PriceInfo = styled.div`
	font-size: ${(props) => props.theme.typography.sizes.lg};
	font-weight: ${(props) => props.theme.typography.weights.semibold};
	color: ${(props) => props.theme.colors.primary.main};
	margin: ${(props) => props.theme.spacing.md} 0;
`;

const ContactInfo = styled.div`
	display: flex;
	gap: ${(props) => props.theme.spacing.md};
	margin: ${(props) => props.theme.spacing.lg} 0;

	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		flex-direction: column;
	}
`;

const ContactLink = styled.a`
	padding: ${(props) => props.theme.spacing.sm}
		${(props) => props.theme.spacing.lg};
	border-radius: ${(props) => props.theme.borderRadius.md};
	background: ${(props) => props.theme.colors.primary.main};
	color: white;
	text-decoration: none;
	font-weight: ${(props) => props.theme.typography.weights.medium};
	text-align: center;
	transition: opacity ${(props) => props.theme.transitions.fast};

	&:hover {
		opacity: 0.9;
	}
`;

const ButtonWrapper = styled.div`
	margin-top: ${(props) => props.theme.spacing.lg};
	text-align: right;
`;
